import {
  InputGroup,
  InputGroupAddon,
  InputGroupError,
  InputGroupInput,
} from "@/components/ui/input-group"
import { useResetPassReqForm } from "./model"
import { Label } from "@/components/ui/label"
import { Mail } from "lucide-react"
import { Controller } from "react-hook-form"
import { Button } from "@/components/ui/button"
import { useAutoTranslation } from "@/entities"
import { LANG_KEYS } from "@/shared/constants"

export const ForgotPasswordForm = () => {
  const { t } = useAutoTranslation()
  const { handleSubmit, errors, control, isLoading } = useResetPassReqForm()
  return (
    <form
      className="relative flex h-full w-full flex-col justify-between"
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col gap-4">
        <Controller
          control={control}
          name="email"
          rules={{
            required: {
              value: true,
              message: t(LANG_KEYS.REQUIRED),
            },
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: t(LANG_KEYS.INVALID_EMAIL_FORMAT),
            },
          }}
          render={({ field }) => (
            <div className="flex flex-col gap-2">
              <Label htmlFor="forgot-pass-ask-email">
                {t(LANG_KEYS.EMAIL_ADDRESS)}
              </Label>
              <InputGroup>
                <InputGroupInput
                  id="forgot-pass-ask-email"
                  type="email"
                  autoFocus
                  autoComplete="email"
                  placeholder="name@example.com"
                  value={field.value}
                  onChange={field.onChange}
                  aria-invalid={!!errors.email}
                />
                <InputGroupAddon>
                  <Mail />
                </InputGroupAddon>
                <InputGroupError>{errors.email?.message}</InputGroupError>
              </InputGroup>
            </div>
          )}
        />
      </div>

      <Button type="submit" isLoading={isLoading} className="h-11 font-medium">
        {t(LANG_KEYS.SEND_EMAIL)}
      </Button>
    </form>
  )
}
